import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FormTextbox } from '../model-form/form-textbox';
import { FormDropdown } from '../model-form/form-dropdown';
import { LoginService } from '../servicios/login-service.service';

@Injectable({
  providedIn: 'root'
})
export class Utils {
  constructor(public router: Router, private servicioLogin: LoginService,) {}

  public setRuta() {
    sessionStorage.setItem('ruta', this.router.url);
  }

  public cerrarSesion (){
    this.servicioLogin.setUserLoggedOut();
  }

  public formatFormulario(data) {
    //console.log(JSON.stringify(data));
    let arrayDatos = [];
    let parametrosDestino: any[] = [];
    let procedimientoDestino: string = '';
    data.forEach(element => {
      //let respuesta = "";

      //alert(JSON.stringify(element));
      parametrosDestino.push({
        key: element.key,
        parametro: element.parametroDestino
      });
      procedimientoDestino = element.procedimientoDestino;
      if (element.required == 1) {
        element.required = true;
      } else {
        element.required = false;
      }

      if (
        element.type == 'text' ||
        element.type == 'password' ||
        element.type == 'email' ||
        element.type == 'number' ||
        element.type == 'date'
      ) {
        //alert(JSON.stringify(element));
        arrayDatos.push(new FormTextbox(element));
      } else if (element.type == 'dropdown') {
        arrayDatos.push(new FormDropdown(element));
      }
    });

    const response = {
      parametros: parametrosDestino,
      arrayDatos: arrayDatos
    };

    //alert(JSON.stringify(response));

    return response;
  }


  public getUsuarioSesion() {
    let infoUsuario: any;
    infoUsuario = sessionStorage.getItem('infoUsuario');
    if (
      !(infoUsuario === '' || infoUsuario == null || infoUsuario === undefined)
    ) {
      infoUsuario = JSON.parse(infoUsuario);
    } else {
      infoUsuario = '';
    }
    return infoUsuario;
  }


  public getRandom(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }


 public guardarIdTabla(idtabla)
 {
  sessionStorage.setItem('idTabla', idtabla);
 }
 public consultarIdTabla(){
  var idTabla = sessionStorage.getItem('idTabla');
  return idTabla;
 }
}
